<template>
  <div>
    <v-row class="hidden-screen-only d-print px-2">
      <print />
    </v-row>
    <v-row class="d-print-none">
      <v-col
        cols="12"
        md="8"
      >
        <v-card
          outlined
          class="pa-9"
        >
          <v-card-text>
            <v-col
              cols="12"
              md="11"
            >
              <v-text-field
                v-model="mailBox.emailTo"
                hide-details="auto"
                label="Email sale invoice"
                type="email"
                placeholder="mail@example.com"
              />
            </v-col>
            <v-col
              cols="12"
              md="1"
            >
              <v-btn
                class="success"
                :disabled="!mailBox.emailTo"
                @click="emailInvocie"
              >
                Send
              </v-btn>
            </v-col>
          </v-card-text>
          <v-card-text>
            <v-alert
              type="success"
              outlined
            >
              <h1>
                Sell Complete
              </h1>
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-col cols="12">
              <v-btn
                class="info"
                block
                @click="newSale"
              >
                New Sale
              </v-btn>
            </v-col>
          </v-card-actions>
          <v-card-actions class="mt-5">
            <v-btn @click="printIt">
              <v-icon>mdi-printer</v-icon>
              Print
            </v-btn>
            <v-spacer />
            <v-btn @click="newSale">
              <v-icon>mdi-new-box</v-icon>
              Next
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-card outlined>
          <v-card-text>
            <v-btn
              block
              color="error"
              x-large
              @click.prevent="exportSale(sale)"
            >
              Download PDF
            </v-btn>
            <v-btn
              block
              color="info"
              class="mt-4"
              x-large
              target="_blank"
              :href="'/print/print-sale/' + sale"
            >
              Print Preview
            </v-btn>
            <v-btn
              block
              color="info"
              class="mt-4"
              x-large
              target="_blank"
              :href="'/print/shipping-address/' + sale"
            >
              Print Shipping Address
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Print from "../print/SaleInvoice.vue";
export default {
  components: {
    print: Print,
  },
  data() {
    return {
      mailBox: {},
    };
  },
  computed: {
    ...mapGetters({
      sale: "misc/currentSale",
    }),
  },

  methods: {
    ...mapActions({
      clearCart: "cart/clear",
      feedback: "snackbar/show",
    }),
    emailInvocie() {
      const form = this.$data.mailBox;
      window.axios
        .post("/email-sale-invoice/" + this.sale, form)
        .then((response) => {
          this.feedback(response.data.message);
          this.$data.mailBox.emailTo = null;
        });
    },
    printPreview(sale) {
      this.$router.replace({ name: "PrintSale", params: { id: sale } });
    },
    exportSale(invoice) {
      Event.$emit("exportPdfSale", invoice);
    },
    printIt() {
      window.print();
    },
    newSale() {
      this.clearCart();
      Event.$emit("salePlaced");
    },
  },
};
</script>
